import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { ProjectSynthesisJobType } from '@Pages/RetroSynthesis/constants';
import RsLoaderHorizontal from '@Pages/RetroSynthesis/components/RsLoader/RsLoaderHorizontal';

const RoutesLoaderInProgress = ({ type }) => {
  return (
    <>
      <RsLoaderHorizontal
        className={cn(
          'project-status-grid-item__routes-loader',
          'project-status-grid-item__routes-loader--in-progress',
          `project-status-grid-item__routes-loader--${type}`
        )}
      />
      <span className="project-status-grid-item__routes-loader-label">In progress</span>
    </>
  );
};

RoutesLoaderInProgress.propTypes = {
  type: PropTypes.oneOf(ProjectSynthesisJobType.allTypes),
};

export default RoutesLoaderInProgress;
